// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2023 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

:root {
  --theia-notebook-markdown-size: 17px;
}

.theia-notebook-cell-list {
  overflow-y: auto;
  list-style: none;
  padding-left: 0px;
  background-color: var(--theia-notebook-editorBackground);
}

.theia-notebook-cell {
  cursor: grab;
  display: flex;
  margin: 10px 0px;
}

.theia-notebook-cell:hover .theia-notebook-cell-marker {
  visibility: visible;
}

.theia-notebook-cell-marker {
  background-color: var(--theia-notebook-inactiveFocusedCellBorder);
  width: 3px;
  margin: 0px 8px 0px 4px;
  border-radius: 4px;
  visibility: hidden;
}

.theia-notebook-cell-marker-selected {
  visibility: visible;
  background-color: var(--theia-notebook-focusedCellBorder);
}

.theia-notebook-cell-marker:hover {
  width: 5px;
  margin: 0px 6px 0px 4px;
}

.theia-notebook-cell-content {
  flex: 1;
  width: calc(100% - 15px);
}

.theia-notebook-markdown-content {
  padding: 8px 16px 8px 36px;
  font-size: var(--theia-notebook-markdown-size);
}

.theia-notebook-markdown-content > *:first-child {
  margin-top: 0;
  padding-top: 0;
}

.theia-notebook-markdown-content > *:only-child,
.theia-notebook-markdown-content > *:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
}

.theia-notebook-empty-markdown {
  opacity: 0.6;
}

.theia-notebook-cell-editor {
  padding: 10px 10px 0 10px;
}

.theia-notebook-cell-editor-container {
  width: calc(100% - 46px);
  flex: 1;
  outline: 1px solid var(--theia-notebook-cellBorderColor);
  margin: 0px 10px;
}

.theia-notebook-cell.focused .theia-notebook-cell-editor-container {
  outline-color: var(--theia-notebook-focusedEditorBorder);
}

.notebook-cell-status {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  height: 16px;
}

.notebook-cell-status-left {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
}

.notebook-cell-status-right {
  margin: 0 5px;
}

.notebook-cell-status-item {
  margin: 0 3px;
  padding: 0 3px;
  display: flex;
  align-items: center;
}

.theia-notebook-cell-toolbar {
  border: 1px solid var(--theia-notebook-cellToolbarSeparator);
  display: flex;
  position: absolute;
  margin: -20px 0 0 66px;
  padding: 2px;
  background-color: var(--theia-editor-background);
}

.theia-notebook-cell-sidebar {
  display: flex;
  flex-direction: column;
  padding: 2px;
  background-color: var(--theia-editor-background);
}

.theia-notebook-cell-toolbar-item {
  height: 18px;
  width: 18px;
}

.theia-notebook-cell-toolbar-item:hover {
  background-color: var(--theia-toolbar-hoverBackground);
}

.theia-notebook-cell-toolbar-item:active {
  background-color: var(--theia-toolbar-active);
}

.theia-notebook-cell-divider {
  height: 20px;
  width: 100%;
}

.theia-notebook-cell-with-sidebar {
  display: flex;
  flex-direction: row;
}

.theia-notebook-cell-sidebar {
  display: flex;
  flex-direction: column;
}

.theia-notebook-main-toolbar {
  position: sticky;
  top: 0;
  background: var(--theia-editor-background);
  display: flex;
  flex-direction: row;
  z-index: 1;
  /*needed to be on rendered on top of monaco editors*/
}

.theia-notebook-main-toolbar-item {
  height: 22px;
  display: flex;
  align-items: center;
  margin: 0 4px;
  padding: 2px;
  text-align: center;
  color: var(--theia-foreground) !important;
  cursor: pointer;
}

.theia-notebook-main-toolbar-item:hover {
  background-color: var(--theia-toolbar-hoverBackground);
}

.theia-notebook-main-toolbar-item-text {
  padding: 0 4px;
}

.theia-notebook-toolbar-separator {
  width: 1px;
  background-color: var(--theia-notebook-cellToolbarSeparator);
  margin: 0 4px;
}

.theia-notebook-add-cell-buttons {
  justify-content: center;
  display: flex;
}

.theia-notebook-add-cell-button {
  border: 1px solid var(--theia-notebook-cellToolbarSeparator);
  background-color: var(--theia-editor-background);
  color: var(--theia-foreground);
  vertical-align: middle;
  text-align: center;
  height: 24px;
  margin: 0 8px;
}

.theia-notebook-add-cell-button:hover {
  background-color: var(--theia-toolbar-hoverBackground);
}

.theia-notebook-add-cell-button:active {
  background-color: var(--theia-toolbar-active);
}

.theia-notebook-add-cell-button-icon {
  vertical-align: middle;
}

.theia-notebook-cell-output-webview {
  padding: 5px 0px;
  margin: 0px 10px;
  width: 100%;
}

.theia-notebook-cell-drop-indicator {
  height: 2px;
  background-color: var(--theia-notebook-focusedCellBorder);
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/notebook/src/browser/style/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,wDAAwD;AAC1D;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iEAAiE;EACjE,UAAU;EACV,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,OAAO;EACP,wDAAwD;EACxD,gBAAgB;AAClB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,4DAA4D;EAC5D,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,oDAAoD;AACtD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,4DAA4D;EAC5D,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,4DAA4D;EAC5D,gDAAgD;EAChD,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yDAAyD;EACzD,WAAW;AACb","sourcesContent":["/********************************************************************************\n * Copyright (C) 2023 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n:root {\n  --theia-notebook-markdown-size: 17px;\n}\n\n.theia-notebook-cell-list {\n  overflow-y: auto;\n  list-style: none;\n  padding-left: 0px;\n  background-color: var(--theia-notebook-editorBackground);\n}\n\n.theia-notebook-cell {\n  cursor: grab;\n  display: flex;\n  margin: 10px 0px;\n}\n\n.theia-notebook-cell:hover .theia-notebook-cell-marker {\n  visibility: visible;\n}\n\n.theia-notebook-cell-marker {\n  background-color: var(--theia-notebook-inactiveFocusedCellBorder);\n  width: 3px;\n  margin: 0px 8px 0px 4px;\n  border-radius: 4px;\n  visibility: hidden;\n}\n\n.theia-notebook-cell-marker-selected {\n  visibility: visible;\n  background-color: var(--theia-notebook-focusedCellBorder);\n}\n\n.theia-notebook-cell-marker:hover {\n  width: 5px;\n  margin: 0px 6px 0px 4px;\n}\n\n.theia-notebook-cell-content {\n  flex: 1;\n  width: calc(100% - 15px);\n}\n\n.theia-notebook-markdown-content {\n  padding: 8px 16px 8px 36px;\n  font-size: var(--theia-notebook-markdown-size);\n}\n\n.theia-notebook-markdown-content > *:first-child {\n  margin-top: 0;\n  padding-top: 0;\n}\n\n.theia-notebook-markdown-content > *:only-child,\n.theia-notebook-markdown-content > *:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.theia-notebook-empty-markdown {\n  opacity: 0.6;\n}\n\n.theia-notebook-cell-editor {\n  padding: 10px 10px 0 10px;\n}\n\n.theia-notebook-cell-editor-container {\n  width: calc(100% - 46px);\n  flex: 1;\n  outline: 1px solid var(--theia-notebook-cellBorderColor);\n  margin: 0px 10px;\n}\n\n.theia-notebook-cell.focused .theia-notebook-cell-editor-container {\n  outline-color: var(--theia-notebook-focusedEditorBorder);\n}\n\n.notebook-cell-status {\n  display: flex;\n  flex-direction: row;\n  font-size: 12px;\n  height: 16px;\n}\n\n.notebook-cell-status-left {\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n}\n\n.notebook-cell-status-right {\n  margin: 0 5px;\n}\n\n.notebook-cell-status-item {\n  margin: 0 3px;\n  padding: 0 3px;\n  display: flex;\n  align-items: center;\n}\n\n.theia-notebook-cell-toolbar {\n  border: 1px solid var(--theia-notebook-cellToolbarSeparator);\n  display: flex;\n  position: absolute;\n  margin: -20px 0 0 66px;\n  padding: 2px;\n  background-color: var(--theia-editor-background);\n}\n\n.theia-notebook-cell-sidebar {\n  display: flex;\n  flex-direction: column;\n  padding: 2px;\n  background-color: var(--theia-editor-background);\n}\n\n.theia-notebook-cell-toolbar-item {\n  height: 18px;\n  width: 18px;\n}\n\n.theia-notebook-cell-toolbar-item:hover {\n  background-color: var(--theia-toolbar-hoverBackground);\n}\n\n.theia-notebook-cell-toolbar-item:active {\n  background-color: var(--theia-toolbar-active);\n}\n\n.theia-notebook-cell-divider {\n  height: 20px;\n  width: 100%;\n}\n\n.theia-notebook-cell-with-sidebar {\n  display: flex;\n  flex-direction: row;\n}\n\n.theia-notebook-cell-sidebar {\n  display: flex;\n  flex-direction: column;\n}\n\n.theia-notebook-main-toolbar {\n  position: sticky;\n  top: 0;\n  background: var(--theia-editor-background);\n  display: flex;\n  flex-direction: row;\n  z-index: 1;\n  /*needed to be on rendered on top of monaco editors*/\n}\n\n.theia-notebook-main-toolbar-item {\n  height: 22px;\n  display: flex;\n  align-items: center;\n  margin: 0 4px;\n  padding: 2px;\n  text-align: center;\n  color: var(--theia-foreground) !important;\n  cursor: pointer;\n}\n\n.theia-notebook-main-toolbar-item:hover {\n  background-color: var(--theia-toolbar-hoverBackground);\n}\n\n.theia-notebook-main-toolbar-item-text {\n  padding: 0 4px;\n}\n\n.theia-notebook-toolbar-separator {\n  width: 1px;\n  background-color: var(--theia-notebook-cellToolbarSeparator);\n  margin: 0 4px;\n}\n\n.theia-notebook-add-cell-buttons {\n  justify-content: center;\n  display: flex;\n}\n\n.theia-notebook-add-cell-button {\n  border: 1px solid var(--theia-notebook-cellToolbarSeparator);\n  background-color: var(--theia-editor-background);\n  color: var(--theia-foreground);\n  vertical-align: middle;\n  text-align: center;\n  height: 24px;\n  margin: 0 8px;\n}\n\n.theia-notebook-add-cell-button:hover {\n  background-color: var(--theia-toolbar-hoverBackground);\n}\n\n.theia-notebook-add-cell-button:active {\n  background-color: var(--theia-toolbar-active);\n}\n\n.theia-notebook-add-cell-button-icon {\n  vertical-align: middle;\n}\n\n.theia-notebook-cell-output-webview {\n  padding: 5px 0px;\n  margin: 0px 10px;\n  width: 100%;\n}\n\n.theia-notebook-cell-drop-indicator {\n  height: 2px;\n  background-color: var(--theia-notebook-focusedCellBorder);\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
